import { useQuery } from 'react-query'
import FutureContractsService from '~/api/services/futureContracts'
import { onError } from '~/utils/helpers'

const getContractsData = () => useQuery(
  'stonex-contracts-data',
  FutureContractsService.getContractsData,
  {
    onError,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data as StoneXOptions
    }
  }
)

const getStoneXContracts = (data) => useQuery(
  'stonex-contracts-index-data',
  () => FutureContractsService.getStoneXContracts(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getStoneXContractsCount = (data) => useQuery(
  'stonex-contracts-count',
  () => FutureContractsService.getStoneXContractsCount(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

export const FutureContractsQuery = {
  getContractsData,
  getStoneXContracts,
  getStoneXContractsCount
}

type KeyValue = {
  key: string; // Keys seem to be numbers or strings depending on the context
  label: string | number; // Labels are also sometimes numbers (like years)
}

type Identifiable = {
  id: string;
  name?: string;
  slug?: string;
  label?: string;
}

type Status = KeyValue

type Month = KeyValue

type Year = KeyValue

interface Commodity extends Identifiable {
  slug: string;
  label: string;
}

interface Exchange extends Identifiable {
  name: string;
}

type Type = KeyValue
export interface StoneXOptions {
  statuses: Status[];
  months: Month[];
  years: Year[];
  commodities: Commodity[];
  exchanges: Exchange[];
  types: Type[];
}
